import React from "react";

const FLAGS = {
    cs: (
        <svg viewBox="0 0 30 20">
            <rect width="30" height="10" fill="#fff" />
            <rect y="10" width="30" height="10" fill="#d7141a" />
            <path d="M0 0 15 10 0 20z" fill="#11457e" />
        </svg>
    ),
    pl: (
        <svg viewBox="0 0 30 20">
            <rect width="30" height="10" fill="#fff" />
            <rect y="10" width="30" height="10" fill="#dc143c" />
        </svg>
    ),
    sv: (
        <svg viewBox="0 0 16 10">
            <rect width="16" height="10" fill="#006aa7" />
            <rect x="5" width="2" height="10" fill="#fecc02" />
            <rect y="4" width="16" height="2" fill="#fecc02" />
        </svg>
    ),
    fi: (
        <svg viewBox="0 0 18 11">
            <rect width="18" height="11" fill="#fff" />
            <rect x="5" width="3" height="11" fill="#002f6c" />
            <rect y="4" width="18" height="3" fill="#002f6c" />
        </svg>
    ),
    tr: (
        <svg viewBox="0 -30000 90000 60000">
            <path fill="#e30a17" d="M0-30000h90000v60000H0z" />
            <path
                fill="#fff"
                d="m41750 0 13568-4408-8386 11541V-7133l8386 11541zm925 8021a15000 15000 0 1 1 0-16042 12000 12000 0 1 0 0 16042z"
            />
        </svg>
    ),
};

export type FlagLanguage = keyof typeof FLAGS;

export const LanguageFlag = ({ lang }: { lang: FlagLanguage }) => (
    <span className="language-flag">{FLAGS[lang]}</span>
);
